/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MDIBaseService } from '../mdi-base-service';
import { MDIApiConfiguration } from '../mdi-api-configuration';
import { MDIStrictHttpResponse } from '../mdi-strict-http-response';

import { qualificationTypeIdGet } from '../fn/qualification-type/qualification-type-id-get';
import { QualificationTypeIdGet$Params } from '../fn/qualification-type/qualification-type-id-get';
import { QualificationTypeModel } from '../models/qualification-type-model';
import { QualificationTypeModelSearchResultModel } from '../models/qualification-type-model-search-result-model';
import { qualificationTypePost } from '../fn/qualification-type/qualification-type-post';
import { QualificationTypePost$Params } from '../fn/qualification-type/qualification-type-post';
import { qualificationTypeSearchQualificationTypePost } from '../fn/qualification-type/qualification-type-search-qualification-type-post';
import { QualificationTypeSearchQualificationTypePost$Params } from '../fn/qualification-type/qualification-type-search-qualification-type-post';

@Injectable({ providedIn: 'root' })
export class MDIQualificationTypeService extends MDIBaseService {
  constructor(config: MDIApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `qualificationTypeSearchQualificationTypePost()` */
  static readonly QualificationTypeSearchQualificationTypePostPath = '/QualificationType/SearchQualificationType';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `qualificationTypeSearchQualificationTypePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  qualificationTypeSearchQualificationTypePost$Response(params?: QualificationTypeSearchQualificationTypePost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<QualificationTypeModelSearchResultModel>> {
    return qualificationTypeSearchQualificationTypePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `qualificationTypeSearchQualificationTypePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  qualificationTypeSearchQualificationTypePost(params?: QualificationTypeSearchQualificationTypePost$Params, context?: HttpContext): Observable<QualificationTypeModelSearchResultModel> {
    return this.qualificationTypeSearchQualificationTypePost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<QualificationTypeModelSearchResultModel>): QualificationTypeModelSearchResultModel => r.body)
    );
  }

  /** Path part for operation `qualificationTypeIdGet()` */
  static readonly QualificationTypeIdGetPath = '/QualificationType/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `qualificationTypeIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  qualificationTypeIdGet$Response(params: QualificationTypeIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<QualificationTypeModel>> {
    return qualificationTypeIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `qualificationTypeIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  qualificationTypeIdGet(params: QualificationTypeIdGet$Params, context?: HttpContext): Observable<QualificationTypeModel> {
    return this.qualificationTypeIdGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<QualificationTypeModel>): QualificationTypeModel => r.body)
    );
  }

  /** Path part for operation `qualificationTypePost()` */
  static readonly QualificationTypePostPath = '/QualificationType';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `qualificationTypePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  qualificationTypePost$Response(params?: QualificationTypePost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<string>> {
    return qualificationTypePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `qualificationTypePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  qualificationTypePost(params?: QualificationTypePost$Params, context?: HttpContext): Observable<string> {
    return this.qualificationTypePost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<string>): string => r.body)
    );
  }

}
